<template>
  <div class="dropdown-menu-container">
    <b-dropdown
      id="dropdown-offset"
      offset="25"
      variant="light"
      text="Цэс"
      right
      class="my-dropdown m-2"
    >
      <b-dropdown-item :to="{name: 'Profile'}" v-if="type === 'student'"
        ><person /> <span class="menu-text">ТА</span></b-dropdown-item
      >
      <b-dropdown-item :to="{name: 'TeacherProfile'}" v-if="type === 'teacher'"
        ><person /> <span class="menu-text">ТА</span></b-dropdown-item
      >
      <b-dropdown-item :to="{name: 'LevelStage'}" v-if="type === 'student'"
        ><star /> <span class="menu-text">БАГЦ</span></b-dropdown-item
      >
      <b-dropdown-item :to="{name: 'TeacherReq'}" v-if="type === 'teacher'"
        ><bell /> <span class="menu-text">Багцын эрх</span></b-dropdown-item
      >
      <b-dropdown-item :to="{name: 'RegisterUser'}" v-if="type === 'teacher'"
        ><star /> <span class="menu-text">Сурагчид</span></b-dropdown-item
      >
      <b-dropdown-item :to="{name: 'Recommend'}" v-if="type === 'student'"
        ><bell /> <span class="menu-text">ЗӨВЛӨМЖ</span></b-dropdown-item
      >
      <b-dropdown-item @click="logout"
        ><exit class="exit" />
        <span class="menu-text">ГАРАХ</span></b-dropdown-item
      >
    </b-dropdown>
  </div>
</template>

<script>
import user from "../mixins/user";
import bell from "../components/icons/bell.vue";
import star from "../components/icons/star.vue";
import exit from "../components/icons/exit.vue";
import person from "../components/icons/person.vue";

export default {
  mixins: [user],
  data() {
    return {
      isVisibe: false,
      visible: "",
    };
  },
  components: {
    bell,
    star,
    exit,
    person,
  },
  methods: {
    logout: function () {
      this.$store.commit("logout");
      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style>
.menu-text {
  margin-left: 1.3em;
}

.my-dropdown .dropdown-toggle {
  font-size: 1.4em;
}

.my-dropdown .dropdown-menu {
  outline: none;
  right: 0;
  transition: all 0.5s;
}

.my-dropdown .dropdown-item {
  min-width: 200px;
  padding: 0.45em 1.5em;
}

.exit {
  margin: 10px;
}
</style>
